import Page from '@service-victoria/component-library/components/Page';
import Text from '@service-victoria/component-library/components/Text';
import bannerImg from 'assets/great-ocean-image.jpg';
import React from 'react';
import styled from 'styled-components';
import { constants } from 'utils';

const PageWrapper = styled(Page)``;

export default function QuotaExceeded() {
  return (
    <PageWrapper
      title={constants.Page.title}
      showFooter
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      opacityBetweenLoading={0}>
      <Text.Heading.H2 style={{ fontWeight: 'bold' }}>ALLOCATION EXHAUSTED</Text.Heading.H2>
      <Text.Body>Sorry. There are no more vouchers available.</Text.Body>
    </PageWrapper>
  );
}
